// The last good business-data state, kept when a refresh fails (2026-10-05). Every field
// the hook stores is carried over - including the role-scoped ones (view, self, shifts,
// totals) that My Home depends on - with safe empties for anything missing or malformed.
const arr = (v) => (Array.isArray(v) ? v : []);

export function keepLastGood(prev = {}) {
  const p = prev || {};
  return {
    employees: arr(p.employees),
    clients: arr(p.clients),
    sites: arr(p.sites),
    companyInfo: p.companyInfo || {},
    platformModules: arr(p.platformModules),
    realTimeMetrics: p.realTimeMetrics || {},
    financialAnalysis: p.financialAnalysis || null,
    summary: p.summary || {},
    view: p.view || null,
    self: p.self || null,
    shifts: arr(p.shifts),
    totals: p.totals || null,
  };
}

// Labels/values for the dashboard AVG BILL RATE tile: client bill rates only (by site and
// weighted by hours), computed server-side in businessService.calculateRateMetrics.
export function rateTileProps(a) {
  const x = a || {};
  const rated = x.clientBillRateCount || 0;
  const missing = Array.isArray(x.clientsWithoutRate) ? x.clientsWithoutRate : [];
  const parts = [];
  if (rated > 0) parts.push(`${rated} client${rated === 1 ? '' : 's'} with a rate`);
  if (missing.length > 0) parts.push(`${missing.join(', ')}: rate not set`);
  return {
    label: 'AVG BILL RATE',
    bySite: { label: 'by site', value: x.avgClientBillRate ?? null },
    byHours: { label: 'by hours worked', value: x.avgClientBillRateByHours ?? null },
    sub: parts.length > 0 ? parts.join(' · ') : 'No client bill rates set',
  };
}
